module.exports = __webpack_public_path__ + "static/media/ignore_patient_huddle.c413d6ee.jpg";